// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_n3-0";
export var buttonContainer = "_n3-3";
export var cancelButton = "_n3-4";
export var headerSection = "_n3-6";
export var headerTitle = "_n3-9";
export var messageSideLeft = "_n3-1";
export var messageSideRight = "_n3-2";
export var orderNumberContainer = "_n3-7";
export var orderNumberLabel = "_n3-8";
export var submitButton = "_n3-5";